import { render, staticRenderFns } from "./ClientInformation.vue?vue&type=template&id=3fba970d"
import script from "./ClientInformation.vue?vue&type=script&lang=ts"
export * from "./ClientInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports